import { Exceptions } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToastrService } from 'ngx-toastr';
import { ToolsService } from '../services/tools.service';
import { ExceptionsService } from './exceptions.service';

@Component({
  selector: 'app-sbeditor-tool-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrls: ['./exceptions.component.scss']
})
export class ExceptionsComponent {
  public tool: Exceptions;
  private subscriptions: Array<Subscription>;
  public postedFile: any;
  public downloadTemplate: SafeUrl;
  @Output() exportTool = new EventEmitter<Exceptions>();

  constructor(
    private sblibService: SblibService,
    private toolsService: ToolsService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private excptionsService: ExceptionsService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.exceptions) {
        this.tool = Object.assign({}, res.exceptions);
      } else {
        console.error('exceptions tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);

    this.generateTemplate();

    var tempFile = this.excptionsService.getTempFile();
    if (tempFile) {
      this.postedFile = tempFile;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  private generateTemplate(): void {
    let template = ["S_1", "S_2"];

    let data = JSON.stringify(template);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }

  private readFile(file) {
    this.postedFile = file;
    this.excptionsService.saveTempFile(file);

    const fileReader = new FileReader();
    fileReader.readAsText(this.postedFile, 'UTF-8');
    fileReader.onload = () => {
      this.tool.data = JSON.parse(fileReader.result.toString());
      const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
        res.exceptions = this.tool;
        this.sblibService.apply(res);
      });
      this.subscriptions.push(tools$);
    };
  }

  public getTool() {
    return this.tool;
  }

  public onFileSelected($event) {
    this.postedFile = null;
    if (!$event.target.files.length) return;

    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      $event.target.files[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    const file = $event.target.files[0];
    this.readFile(file);
  }

  public onFileDropped($event) {
    this.postedFile = null;
    if (!$event.length) return;

    if (
      ($event[0].type == '' && $event[0].size == 0) ||
      $event[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }

    this.readFile($event[0]);
  }

  public deleteDroppedFile() {
    this.postedFile = null;
    this.tool.data = null;
    this.tool.file = null;
  }

  public apply() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.exceptions = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success('', 'exceptions guardados');
    });
    this.subscriptions.push(tools$);
  }
}
